<template>
    <div>
        <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />
        <v-dialog v-model="dialog" max-width="1300" persistent>
            <v-card class="blog-dialog">
                <v-card-title class="text-h5 pa-5">
                    Add User Guidelines
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-0 d-flex flex-column">
                    <v-form ref="form" class="h-100 d-flex flex-column">
                        <v-row no-gutters class="dialog-content">
                            <!-- LEFT -->
                            <v-col cols="12" md="4" class="left-panel pa-5" style="border-right:1px solid #e0e0e0;">

                                <div class="text-subtitle-1 font-weight-medium mb-3">
                                    Attachments
                                </div>

                                <v-btn block color="primary" prepend-icon="mdi-paperclip" :loading="uploadingAttachment"
                                    @click="$refs.attachmentInput.click()">
                                    Upload Image / Video
                                </v-btn>

                                <input ref="attachmentInput" type="file" class="d-none" accept="image/*,video/*"
                                    multiple @change="onAttachmentSelected" />

                                <v-row class="mt-4" dense>
                                    <v-col cols="12" v-for="(path, index) in formData.attachments" :key="index">
                                        <v-card variant="outlined" class="pa-2 d-flex align-center">
                                            <v-avatar rounded size="60">
                                                <v-icon v-if="isImage(path)" color="primary" size="36">
                                                    mdi-image
                                                </v-icon>

                                                <v-icon v-else-if="isVideo(path)" color="red" size="36">
                                                    mdi-video
                                                </v-icon>

                                                <v-icon v-else size="36">
                                                    mdi-file
                                                </v-icon>
                                            </v-avatar>

                                            <div class="ml-3 flex-grow-1">
                                                <div class="font-weight-medium">
                                                    {{ getFileName(path) }}
                                                </div>

                                                <div class="text-caption">
                                                    {{ getFileType(path) }}
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                </v-row>

                            </v-col>

                            <!-- RIGHT -->
                            <v-col cols="12" md="8" class="pa-6 right-panel">
                                <div class="right-scroll">
                                    <div class="rich-text-editor">
                                        <v-card variant="outlined" class="editor-container">

                                            <div class="editor-toolbar">
                                                <v-btn icon @click="formatText('bold')">
                                                    <v-icon>mdi-format-bold</v-icon>
                                                </v-btn>

                                                <v-btn icon @click="formatText('italic')">
                                                    <v-icon>mdi-format-italic</v-icon>
                                                </v-btn>

                                                <v-btn icon @click="formatText('underline')">
                                                    <v-icon>mdi-format-underline</v-icon>
                                                </v-btn>

                                                <v-divider vertical class="mx-2" />

                                                <!-- <v-btn icon @click="$refs.imageInput.click()">
                                                    <v-icon>mdi-image-plus</v-icon>
                                                </v-btn>

                                                <v-btn icon @click="$refs.videoInput.click()">
                                                    <v-icon>mdi-video-plus</v-icon>
                                                </v-btn> -->
                                            </div>
                                            <v-divider />

                                            <div ref="editorContent" class="editor-content" contenteditable="true"
                                                @input="handleEditorInput" @keyup="updateToolbarState"
                                                @mouseup="updateToolbarState" @click="updateToolbarState"></div>

                                        </v-card>
                                    </div>
                                </div>

                            </v-col>

                        </v-row>
                    </v-form>
                </v-card-text>

                <v-divider />

                <v-card-actions class="pa-4">
                    <v-spacer />

                    <v-btn variant="text" @click="handleClose" color="grey">
                        Cancel
                    </v-btn>

                    <v-btn color="primary" variant="flat" :loading="loading" @click="handleSubmit">
                        Create User Guide
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
import { edit_user_guide_topic } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import S3AmplifyMixin from "@/mixins/S3Amplify";
const client = generateClient();


export default {
    name: "CreateNestUserGuideDialog",
    components: {
        SnackbarComponent,
    },
    props: {
        modelValue: Boolean,

        UserGuideCreate: {
            type: Object,
            default: () => ({})
        },

        selectedSubGuide: {
            type: Object,
            default: () => ({})
        }
    },
    mixins: [S3AmplifyMixin],
    emits: ["update:modelValue", "created"],
    data() {
        return {
            uploadingAttachment: false,
            loading: false,
            formData: {
                title: "",
                guide_sub_title: "",
                guide_description: "",
                attachments: [],
            },
            activeFormats: {
                bold: false,
                italic: false,
                underline: false,
            },
            snackbar: {
                show: false,
                message: "",
                color: "success",
            },

        };
    },
    computed: {
        dialog: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    watch: {
        modelValue(val) {

            if (!val) return;

            this.resetForm();

            this.formData.title =
                this.UserGuideCreate.title;

            this.formData.guide_sub_title =
                this.selectedSubGuide.subtitle;

            this.formData.guide_description =
                this.selectedSubGuide.guide_description || "";

            this.formData.attachments =
                JSON.parse(JSON.stringify(this.selectedSubGuide.attachments || []));

            this.$nextTick(() => {
                if (this.$refs.editorContent) {
                    this.$refs.editorContent.innerHTML =
                        this.formData.guide_description;
                }
            });
        }
    },
    methods: {
        isImage(path) {
            return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(path);
        },

        isVideo(path) {
            return /\.(mp4|mov|avi|mkv|webm|m4v)$/i.test(path);
        },

        getFileName(path) {
            return path.split("/").pop();
        },

        getFileType(path) {
            if (this.isImage(path)) return "IMAGE";
            if (this.isVideo(path)) return "VIDEO";
            return "FILE";
        },
        async uploadGuideContent() {
            const key = `UserGuide/${this.formData.title}/${Date.now()}/guide-content.json`;

            const payload = {
                guide_description: this.formData.guide_description,
                attachments: this.formData.attachments
            };

            const file = new File(
                [JSON.stringify(payload)],
                "guide-content.json",
                {
                    type: "application/json",
                }
            );

            return await this.uploadFile(file, key, "bms");
        },
        async onAttachmentSelected(event) {

            const files = [...event.target.files];

            if (!files.length) return;

            this.uploadingAttachment = true;

            try {

                for (const file of files) {

                    const isImage = file.type.startsWith("image/");
                    const isVideo = file.type.startsWith("video/");

                    if (!isImage && !isVideo) continue;

                    const key = `UserGuide/${this.formData.title
                        }/Attachments/${file.name}`;

                    const s3Path = await this.uploadFile(
                        file,
                        key,
                        "bms"
                    );

                    this.formData.attachments.push(s3Path);

                }

            } finally {

                this.uploadingAttachment = false;
                event.target.value = "";

            }

        },
        formatText(command) {
            this.$refs.editorContent.focus();

            document.execCommand(command, false, null);

            this.$nextTick(() => {
                this.updateToolbarState();
                this.formData.guide_description =
                    this.$refs.editorContent.innerHTML;
            });
        },

        handleEditorInput() {
            this.formData.guide_description =
                this.$refs.editorContent.innerHTML;
        },

        updateToolbarState() {
            this.$nextTick(() => {
                try {
                    this.activeFormats.bold =
                        document.queryCommandState("bold");
                    this.activeFormats.italic =
                        document.queryCommandState("italic");
                    this.activeFormats.underline =
                        document.queryCommandState("underline");
                } catch (e) { }
            });
        },
        handleClose() {
            this.dialog = false;
            this.resetForm();
        },
        resetForm() {
            this.formData = {
                title: "",
                guide_sub_title: "",
                guide_description: "",
                attachments: [],
            };

            this.$nextTick(() => {
                if (this.$refs.editorContent) {
                    this.$refs.editorContent.innerHTML = "";
                }
            });

            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
        async handleSubmit() {
            const { valid } = await this.$refs.form.validate();

            if (!valid) return;
            this.loading = true;

            try {
                const guideContentPath =
                    await this.uploadGuideContent();

                const modules = JSON.parse(
                    JSON.stringify(this.UserGuideCreate.guide_sub_modules || [])
                );
                const index = modules.findIndex(
                    item => item.subtitle === this.selectedSubGuide.subtitle
                );

                if (index !== -1) {

                    modules[index] = {
                        ...modules[index],
                        subtitle: this.formData.guide_sub_title,

                        guide_content_s3_path: guideContentPath
                    };

                }

                const input = {
                    guide_topic_id: this.selectedSubGuide.guide_topic_id,
                    title: this.selectedSubGuide.title,
                    sub_module_content_s3_path: guideContentPath,
                    sub_module_attachments: this.formData.attachments
                };

                const response = await client.graphql({
                    query: edit_user_guide_topic,
                    variables: {
                        input: input,
                    },
                });

                const responseData = JSON.parse(response.data.edit_user_guide_topic);

                if (responseData.status === "SUCCESS") {
                    this.snackbar = {
                        show: true,
                        message: responseData.status_message || "User Guide created successfully!",
                        color: "success",
                    };
                    this.$emit("created");
                    this.handleClose();
                } else {
                    this.snackbar = {
                        show: true,
                        message: responseData.status_message || "Failed to create User Guide",
                        color: "error",
                    };
                }
            } catch (error) {
                console.error("Error creating User Guide", error);
                this.snackbar = {
                    show: true,
                    message:
                        (error.errors && error.errors[0]?.message) ||
                        error.message ||
                        "An error occurred while creating User Guide",
                    color: "error",
                };
            } finally {
                this.loading = false;
            }
        },
    },
};

</script>

<style>
.blog-dialog {
    height: 85vh;
    display: flex;
    flex-direction: column;
}

.blog-dialog .v-card-text {
    flex: 1;
    overflow: hidden;
    padding: 0;
}

.dialog-content {
    height: 100%;
    margin: 0;
}

/* ---------------- LEFT ---------------- */

.left-panel {
    height: 100%;
    border-right: 1px solid #e0e0e0;

    overflow-y: auto;
    overflow-x: hidden;

    position: sticky;
    top: 0;
}

/* ---------------- RIGHT ---------------- */

.right-panel {
    height: 100%;
    padding: 18px;
    overflow: hidden;
    display: flex;
}

.right-scroll {
    flex: 1;
    overflow: hidden;

    display: flex;
    flex-direction: column;
}

/* ---------------- Editor ---------------- */

.rich-text-editor {
    flex: 1;

    display: flex;
    flex-direction: column;

    min-height: 0;
}

.editor-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 12px;
    overflow: hidden;
}

.editor-toolbar {
    flex-shrink: 0;

    display: flex;
    align-items: center;
    gap: 4px;

    padding: 8px 12px;

    background: #fafafa;
    border-bottom: 1px solid rgba(0, 0, 0, .08);
}

.editor-content {
    flex: 1;

    overflow-y: auto;
    overflow-x: hidden;

    padding: 18px;

    outline: none;

    min-height: 0;

    word-break: break-word;
}

/* Placeholder */

.editor-content:empty::before {
    content: "Write USER Guidlines...";
    color: rgba(0, 0, 0, .45);
    pointer-events: none;
}

.editor-content:focus {
    outline: none;
}

.guide-description {
    line-height: 1.8;
    font-size: 15px;
}

.guide-description img {
    max-width: 100%;
    border-radius: 8px;
}

.guide-description p {
    margin-bottom: 12px;
}

.guide-description ul {
    padding-left: 20px;
}

.guide-description ol {
    padding-left: 20px;
}

/* Typography */

.editor-content p {
    margin-bottom: 12px;
}

.editor-content h1,
.editor-content h2,
.editor-content h3,
.editor-content h4,
.editor-content h5,
.editor-content h6 {
    margin-bottom: 12px;
    font-weight: 600;
}

.editor-content ul,
.editor-content ol {
    padding-left: 24px;
    margin-bottom: 12px;
}

.editor-content img {
    max-width: 100%;
    height: auto;
}

/* Footer */

.blog-dialog .v-card-actions {
    flex-shrink: 0;
    border-top: 1px solid #eee;
    background: white;
}
</style>